import { render } from "./QueueListSort.vue?vue&type=template&id=2bff8bb7&ts=true"
import script from "./QueueListSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueueListSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/queue/components/QueueListSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bff8bb7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bff8bb7', __exports__)) {
    api.reload('2bff8bb7', __exports__)
  }
  
  module.hot.accept("./QueueListSort.vue?vue&type=template&id=2bff8bb7&ts=true", () => {
    api.rerender('2bff8bb7', render)
  })

}


export default __exports__